import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import CardColumn from "../CardColumn";

function CategoryColumn({ row, title, data, add, path = "recents" }) {
  return (
    <Wrapper className={`${row ? "row" : ""}`}>
      <div className="top flex between">
        <h2 className="main-title">
          {add && !data ? "No posts found!" : title}
        </h2>
        {add ? (
          add
        ) : (
          <NavLink to={`/posts?category=${path}`} className="tag">
            View More
          </NavLink>
        )}
      </div>
      <div className="devider"></div>
      <main>
        {data && data.map((i) => (
          <CardColumn tag={false} data={i} row={row} />
        ))}
      </main>
    </Wrapper>
  );
}

export default CategoryColumn;

const Wrapper = styled.div`
  &.row {
    main {
      grid-template-columns: 1fr 1fr;
    }
  }
  main {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    @media (max-width: 991px) {
      grid-template-columns: 1fr 1fr !important;
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr !important;
      gap: 12px;
    }
  }
`;
